import React from 'react';
import { FormBuilder } from 'commons-ui';
import useEdit from './useEdit';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationSchemaEdit } from '../../utils/formConfig';
import { FORM_MODE } from '../../utils/constant';

const EditConfig: React.FC<{}> = () => {
	const { configData, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useEdit();
	return (
		<>
			{Object.keys(configData).length > 0 && (
				<FormBuilder
					data={configData}
					mode={FORM_MODE}
					showLoader={showLoader}
					handleFormSubmit={handleFormSubmit}
					handleFormCancel={handleFormCancel}
					setShowLoader={setShowLoader}
					fieldConfig={FORM_FIELD_CONFIG}
					layoutConfig={FORM_LAYOUT_CONFIG}
					validationSchema={validationSchemaEdit}
				/>
			)}
		</>
	);
};

export default EditConfig;
